<template>
  <div>
    <div class="d-flex">
      <h3 class="me-3">Сервер</h3>

      <ServiceAddOrUpdateServer/>

    </div>
    <br>

    <ServerDashboard v-if="props.serverId" :server-id="props.serverId" :key="props.serverId"/>

  </div>
</template>

<script setup>
import {defineProps} from "vue";
import ServerDashboard from "@/components/servers/ServerDashboard";
import ServiceAddOrUpdateServer from "@/components/services/ServiceAddOrUpdateServer";

const props  = defineProps({
  serverId: Number,
})


</script>
